import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class SharedMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return `### ${params.key} ###`;
  }
}

export function sharedTranslationHttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
    { prefix: '/@shared/assets/i18n/', suffix: '.json' },
    { prefix: '/assets/i18n/', suffix: '.json' }
  ]);
}
export function sharedTranslationHttpLoaderFactory2(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
    { prefix: '/@shared/assets/i18n/', suffix: '.json' },
    { prefix: '/i18n/', suffix: '.json' }
  ]);
}
